// This provides a thinner border than: layout: 'headerLineOnly'
export const bottomBorder = {
  hLineWidth: i => {
    return i === 1 ? 0.25 : 0
  },
  vLineWidth: () => {
    return 0
  },
}

export const docketDetailLayout = {
  hLineWidth: (i, node) => {
    if (i > 2 && i < node.table.body.length) return 0.1

    return i === node.table.body.length ? 0 : i * 0.25
  },
  vLineWidth: () => {
    return 0
  },
}

export const whiteBorders = {
  hLineWidth: function () {
    return 1
  },
  vLineWidth: function () {
    return 0
  },
  hLineColor: function () {
    return 'white'
  },
  vLineColor: function () {
    return 'white'
  },
}

export const addIfDefined = field => field || ''

export const addDashboardData = dashboardData => {
  const tableRows = [[{ text: dashboardData.type + ' for ' + dashboardData.for.join(', '), style: 'header' }]]
  // Replace '-' with '/' in dates to get correct date (one day off otherwise)
  const from = new Date(dashboardData.from.replace(/-/g, '/')).toLocaleDateString()
  const to = new Date(dashboardData.to.replace(/-/g, '/')).toLocaleDateString()
  tableRows.push([{ text: from + ' to ' + to, style: 'subheaderCenter' }])
  return {
    table: {
      widths: ['*'],
      body: tableRows,
    },
    layout: whiteBorders,
  }
}

export const addStandaloneHeader = docketEntries => {
  let title = 'Docket '
  let subtitle = ''
  if (docketEntries && docketEntries.length > 0) {
    const entry = docketEntries[0]
    title += 'for ' + (entry.legal_case_type_label || entry.legal_case_type__label)
    subtitle += 'Record: ' + entry.record_id
    subtitle += ' (Record Holder: ' + (entry.record_holder_name || entry.record_holder_party__name) + ')'
  }
  const tableRows = [
    [{ text: title, style: 'header' }],
    [{ text: subtitle, style: 'subtitle' }],
  ]
  return {
    table: {
      widths: ['*'],
      body: tableRows,
    },
    layout: whiteBorders,
  }
}

export const addDocketEntries = docketEntries => {
  const tableRows = []
  const docketEntryRows = []
  docketEntryRows.push([
    { text: 'Date', style: 'subheaderFill' },
    { text: 'Start - End', style: 'subheaderFill' },
    { text: 'Type', style: 'subheaderFill' },
    { text: 'Name', style: 'subheaderFill' },
    { text: 'Complete', style: 'subheaderFill' },
    { text: 'Assignees', style: 'subheaderFill' },
    { text: 'Comment', style: 'subheaderFill' }])
  docketEntries.forEach(entry => {
    const start = entry.event_time_start ? entry.event_time_start : ''
    const end = entry.event_time_end ? entry.event_time_end : ''
    docketEntryRows.push([
      entry.action_date,
      start + ' - ' + end,
      entry.docket_entry_type_action || entry.docket_entry_type__action,
      entry.docket_entry_type_name || entry.docket_entry_type__name,
      entry.is_done ? 'Yes' : 'No',
      addIfDefined(entry.assignees),
      addIfDefined(entry.comment),
    ])
  })
  tableRows.push([
    { table: { widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*'], body: docketEntryRows }, layout: docketDetailLayout },
  ])

  return {
    table: {
      widths: ['*'],
      body: tableRows,
    },
    layout: 'noBorders',
  }
}

// NOTE: pdfmake does not use the standard CSS rule (TRBL) for margins:
// Instead, margin: [left, top, right, bottom] (LTRB)
export const docketStyles = {
  header: {
    fontSize: 12,
    bold: true,
    alignment: 'center',
    margin: [0, 5, 0, 5],
  },
  subtitle: {
    fontSize: 10,
    alignment: 'center',
    color: 'gray',
  },
  right: {
    alignment: 'right',
  },
  subheaderCenter: {
    fontSize: 10,
    bold: true,
    margin: [0, 2, 0, 2],
    alignment: 'center',
  },
  subheaderFill: {
    fontSize: 10,
    bold: true,
    margin: [0, 2, 0, 2],
    fillColor: '#eeeeee',
  },
}
